









































import { AdminService } from '../../biz/remote/AdminService';
import { Vue, Component, Prop } from 'vue-property-decorator';
import { Sorter } from '../../utils/Sorter';
import SortTh from '../../components/atoms/SortTh.vue';
import { LessonSummaryDTO } from '../../../src_server/entity/dto/LessonSummaryDTO';
import MatchingRow from './MatchingRow.vue';
import { Session } from '../../utils/Session';

@Component({ components: { SortTh, MatchingRow } })
export default class MatchingListPage extends Vue {
  private value: LessonSummaryDTO[] = [];
  private loading = false;
  get model() {
    return this.value;
  }

  get totalMatching() {
    return this.value.length;
  }

  get totalLessonCount() {
    return this.value.reduce((a, c) => a + c.alr_count, 0);
  }
  get totalDeleteCount() {
    return this.value.reduce((a, c) => a + c.del_count, 0);
  }

  async created() {
    this.loading = true;
    const biz = new AdminService();
    const response = await biz.getLessonSummary(Session.getSessionBuildingId());
    this.value = response.data;
    console.log(this.value.length);
    this.loading = false;
  }

  sortBy(up: boolean, target: any) {
    // console.log(up, target, Sorter.compareByPath(target, up));
    this.value = this.value.sort(Sorter.compareByPath(target, up));
  }
}
